import { useEffect, useState } from 'react';
import { expensesAPI, type ExpenseOptionsDto } from '@matix/api-client';

/**
 * The branch's expense set-up, fetched once per page load and shared — the
 * sidebar asks only "is there anything to show?", the screen needs the lists.
 * A failure reads as "not available": the menu entry simply does not appear.
 */
let cached: Promise<ExpenseOptionsDto> | null = null;

export function loadExpenseOptions(force = false): Promise<ExpenseOptionsDto> {
  if (!cached || force) {
    cached = expensesAPI.options().catch(() => {
      cached = null;
      return { available: false, types: [], tenders: [] };
    });
  }
  return cached;
}

export function useExpensesAvailable(): boolean {
  const [on, setOn] = useState(false);
  useEffect(() => {
    let alive = true;
    void loadExpenseOptions().then((o) => alive && setOn(o.available));
    return () => {
      alive = false;
    };
  }, []);
  return on;
}
